import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { AboutpageService } from 'src/app/features/company/about/aboutpage.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-investors',
  templateUrl: './investors.component.html',
  styleUrls: ['./investors.component.scss'],
  imports: [CommonModule],
})
export class InvestorsComponent implements OnInit, OnDestroy {
  constructor(
    private contentful: ContentfulService,
    private aboutPageService: AboutpageService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  investorData: any;

  ngOnInit(): void {
    this.aboutPageService.aboutInvestor$.subscribe(data => {
      if (data != null) {
        this.investorData = {
          header: data.title,
          logos: data.images,
        };
      }
    });
  }
}
